import { getUser, logout, useEnvironment, useHub } from "../../core/Global";
import { isNativeApp } from "../../NativeAppBrdige";
import Modal from "../base/Modal";


function ModalLogout() {

    const hub = useHub()
    const user = getUser()

    return (
        <Modal id="modal-signout"
            title="Sign Out"
            buttonText="Sign Out"
            buttonColor="danger"
            onConfirm={callback => {
                hub.Get("/auth/logout/" + user?.id, res => {
                    if (res.success) {
                        logout()
                        if (isNativeApp()) {
                            document.location.replace("rinvox://logout")
                        }
                        else {
                            document.location.replace("/auth/login")
                        }
                    }
                    else {
                        callback(true);
                    }
                })
            }}>
            <p>
                Are you sure you want to sign out from the system?
            </p>
        </Modal>
    )
}

export default ModalLogout;